<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form contour-form">
		<div class="kt-login__title">
			<span><i style="font-size: 70px" class="fa fa-user-lock"></i></span>
		</div>

		<!--begin::Form-->

		<div *ngIf="erreurMsg != ''" class="alert alert-solid-danger alert-bold" role="alert">
			<div class="alert-text">
				{{erreurMsg}}
			</div>
		</div>

		<kt-codepin [loading]="loading" [debloquerRetour]="debloquerRetour" (debloquer)="debloquer($event)" [email]="loginForm.controls['email'].value"
					*ngIf="codepin && nbreEssaiePin <= 3"></kt-codepin>
		<form *ngIf="!codepin" class="kt-form" [formGroup]="loginForm" autocomplete="off">
			<div class="form-group">
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput type="email" placeholder="Email"
						   formControlName="email" autocomplete="off"/>
				</mat-form-field>
			</div>
			<div class="form-group">
				<mat-form-field>
					<mat-label>Mot de passe</mat-label>
					<input matInput [type]="show_button ? 'text' : 'password'" placeholder="Mot de passe" formControlName="password"
						   autocomplete="off"/>
					<i  [class]="show_eye ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="showPassword()" mat-button
						matSuffix mat-icon-button aria-label="Clear"></i>
				</mat-form-field>
			</div>
			<!--begin::Action-->
			<div class="kt-login__actions">
				<a href="javascript:;" routerLink="/mdp" class="kt-link kt-login__link-forgot">
					Mot de passe oublié ?
				</a>
				<button [disabled]="loading" (click)="seconnecter()"
						[ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}"
						id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary">
					Se connecter
				</button>
			</div>
			<!--end::Action-->
		</form>
		<!--end::Form-->
	</div>

	<!--end::Signin-->
</div>
<!--
<div *ngIf="publicites.length>0" class="row" style="margin-top: 30px">
	<div class="col-md-1">

	</div>
	<div class="col-md-10">
		<div class="row">
			<div  class="col-md-4 pad5"  *ngFor="let publicite of publicites; let indexa = index " >
				<a href="{{publicite.lienDestination}}" target="_blank" >
					<img  src="{{ url+publicite.image}}"
						  class="taille {{ indexa == 0 ? 'border-one' : indexa== 1 ? 'border-two' : 'border-three' }}"

					>

				</a>
			</div>
		</div>

	</div>

	<div class="col-md-1">

	</div>
</div>
-->
<!--end::Body-->
